<template>
  <div class="contractors-listing">
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />

    <ContractorsActions />

    <div class="radio-control">
      <div class="multi-inline">
        <span class="radio-label">
          <label>{{ $t('contractors.labels.filter') }}</label>
        </span>
        <TolRadioButton
          button-label="Both"
          label="both"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />

        <TolRadioButton
          button-label="Active"
          label="true"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />
        <TolRadioButton
          button-label="Inactive"
          label="false"
          name="activeInactive"
          :value="activeInactive"
          @toggle="onActiveInactiveChange"
        />
      </div>
    </div>

    <tol-table
      :table-data="contractors"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'payrollnums' ? currentSortDirection : 'none'"
          field-name="payrollnums"
          @change="onSortOrderChange"
          >{{ $t('contractors.listing.labels.payroll_number') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'contractorName' ? currentSortDirection : 'none'"
          field-name="contractorName"
          @change="onSortOrderChange"
          >{{ $t('contractors.listing.labels.contractorName') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'entity' ? currentSortDirection : 'none'"
          field-name="entity"
          @change="onSortOrderChange"
          >{{ $t('contractors.listing.labels.entity') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'pay_to_name' ? currentSortDirection : 'none'"
          field-name="pay_to_name"
          @change="onSortOrderChange"
          >{{ $t('contractors.listing.labels.pay_to_name') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'email' ? currentSortDirection : 'none'"
          field-name="email"
          @change="onSortOrderChange"
          >{{ $t('contractors.listing.labels.email') }}</th-sortable
        >
      </template>

      <template v-slot:reference_number="{ value }">
        <router-link :to="value.reference_number">{{ value.reference_number }}</router-link>
      </template>
    </tol-table>

    <Pagination
      :records-per-page="contractorsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import {
  ContractorsListingActions,
  ContractorsListingGetters
} from '@/app/features/contractors/features/contractors-listing/contractors-listing.keys';
import ContractorsActions from '@/app/features/contractors/features/contractors-listing/components/ContractorsActions';
import TolAlert from '@/app/components/TolAlert';
import { AppActions } from '@/app/app.keys';
import TolRadioButton from '@/app/components/TolRadioButton';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';

export default {
  name: 'ContractorsListing',
  components: {
    TolTable,
    TolAlert,
    ContractorsActions,
    ThSortable,
    Pagination,
    TolRadioButton
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    tolAlert() {
      return false;
    },
    contractors() {
      return this.$store.getters[ContractorsListingGetters.ContractorsList];
    },
    contractorsPerPage() {
      return this.$store.getters[ContractorsListingGetters.ContractorsPerPage];
    },
    currentPage() {
      return this.$store.getters[ContractorsListingGetters.ContractorsListingOffset];
    },
    recordCount() {
      return this.$store.getters[ContractorsListingGetters.ContractorsRecordCount];
    },
    currentSortField() {
      return this.$store.getters[ContractorsListingGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[ContractorsListingGetters.SortDirection];
    },
    columns() {
      return ['payrollnums', 'contractorName', 'entity', 'pay_to_name', 'email'];
    },
    activeInactive() {
      return this.$store.getters[ContractorsListingGetters.ContractorsActiveInactive];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('contractors.listing.title'));
    this.$store.dispatch(ContractorsListingActions.RetrieveContractors);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(ContractorsListingActions.SetContractorsSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(ContractorsListingActions.SetContractorsPaginationParameters, event);
    },
    onActiveInactiveChange(activeInactive) {
      this.$store.dispatch(ContractorsListingActions.SetContractorsActiveInactive, activeInactive);
    },
    handleRowClick(evt) {
      this.$router.push(`/contractors/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.contractors-listing {
  list-style-position: inside;
  padding-left: 0;
}

.radio-control {
  display: flex;
  padding: 10px 0;
  margin: 1em;
  flex: 1;
  justify-content: flex-end;
  align-items: flex-end;

  .tol-list ul li .remove {
    width: 30px;
    height: 30px;

    font-size: 1.2em;
    color: $row-border;
    text-align: center;
    float: right;
    &:hover {
      background-color: $row-border;
      border-radius: 100%;
      color: $white;
    }
  }

  .grey {
    color: $grey;
  }
}

.multi-inline {
  display: flex;
  justify-content: flex-start;
  align-content: center;
  background-color: $light-grey-1;
  align-items: flex-end;
  height: 100%;
  padding: 10px 10px 0px 10px;
  > span.radio-label {
    display: flex;
    font-weight: bold;
    margin-bottom: 10px;
  }

  > * {
    margin-left: 1em;
  }
  > *:first-child {
    margin-left: 0;
  }
}
</style>
